function topicPreview(topics, max = 3) {
  if (!topics.length) return 'No topics yet';
  const slice = topics.slice(0, max);
  const extra = topics.length > max ? ` +${topics.length - max} more` : '';
  return `${slice.join(' · ')}${extra}`;
}

const colorMod = (c) => {
  const allowed = ['emerald', 'blue', 'violet', 'amber', 'rose', 'cyan'];
  return allowed.includes(c) ? c : 'emerald';
};

export default function CurriculumSectionsPanel({
  sections,
  selectedId,
  onSelect,
  onAddSection,
  onDeleteSection,
}) {
  return (
    <div className="cb-panel">
      <div className="cb-panel__head">
        <h3>Sections</h3>
        <button type="button" onClick={onAddSection} className="cb-btn-primary-dark">
          + Add section
        </button>
      </div>

      <div className="cb-list-scroll">
        {sections.length === 0 ? (
          <div className="cb-empty">
            <p>No sections yet</p>
            <span>Add a section to start building your curriculum outline.</span>
            <button type="button" onClick={onAddSection} className="cb-btn-blue">
              Add first section
            </button>
          </div>
        ) : (
          sections.map((sec, idx) => {
            const num = idx + 1;
            const selected = sec.id === selectedId;
            const mod = colorMod(sec.color);
            return (
              <div
                key={sec.id}
                role="button"
                tabIndex={0}
                onClick={() => onSelect(sec.id)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onSelect(sec.id);
                  }
                }}
                className={`cb-section-card cb-section-card--${mod} ${selected ? 'is-selected' : ''}`}
              >
                <div className="cb-section-card__row">
                  <div className="cb-section-card__main">
                    <div className="cb-section-card__title-row">
                      <span className="cb-num-badge">{num}</span>
                      <span className="cb-section-card__title">{sec.title || 'Untitled'}</span>
                    </div>
                    <p className="cb-section-card__preview">{topicPreview(sec.topics)}</p>
                  </div>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteSection(sec.id);
                    }}
                    className="cb-icon-btn"
                    title="Delete section"
                    aria-label="Delete section"
                  >
                    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
